import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw = {
  path: '/industry',
  name: 'Industry',
  component: () => import('@/views/organization/industry/index.vue'),
  meta: {
    title: '行业列表',
    icon: 'i-ant-design:appstore-outlined',
    auth: 'industry:list',
    singleMenu: true,
  },
}

export default routes
